import { NET_INCOME_RANGES, type NetIncomeRange } from '../constants/business-finances';

const netIncomeRangeSet = new Set<string>(NET_INCOME_RANGES);

export function isNetIncomeRange(value: string): value is NetIncomeRange {
  return netIncomeRangeSet.has(value);
}

export function toNetIncomeRange(value: string | null | undefined): NetIncomeRange | null {
  if (typeof value !== 'string' || !isNetIncomeRange(value)) return null;
  return value;
}
